import { newAlertify } from 'trunks/vue/admin/components/alert.js';
import Modal from 'trunks/vue/admin/components/modals/modal.js';
import OrganizationSearch from 'trunks/vue/admin/components/search/organization.js';
import CollaboratorsSelection from 'trunks/vue/admin/compositions/collaborators_selection.js';

const DEFAULT_TITLE = '新视图';
const DEFAULT_USER_BOUNDARY = {
  organization_ids: [],
};

export default Vue.extend({
  components: {
    'organization-search': OrganizationSearch,
    modal: Modal,
    'collaborators-selection': CollaboratorsSelection,
  },

  props: {
    dataclipableGID: {
      type: Skylark.Libs.GlobalID,
      required: true,
    },
    resourceGID: {
      type: Skylark.Libs.GlobalID,
      required: true,
    },
  },

  data() {
    return {
      userBoundary: DEFAULT_USER_BOUNDARY,
      title: DEFAULT_TITLE,
      conditions: {},
      selectedCollaboratorIds: [],
    };
  },

  template: `
    <modal title='保存为视图'
           extendClass='dataclip-form-modal'
           :backdrop='true'
           ref='modal'>
      <div class="modal-body">
        <div class="form-field">
          <div class="form-field-head">
            <div class="form-field-title">视图名称：</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input">
              <input class="form-field-value" placeholder="请输入视图名称" type="text" v-model.trim='title'>
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="form-field-head">
            <div class="form-field-title">视图范围（可选）：</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input">
              <organization-search :remote='remoteUrl'
                                   :resources='resourcesUrl'
                                   :eagerLoadChildren='true'
                                   @valueChanged='updateOrganizationsFunc'
                                   organizationNameSuffix='及以下组织'
                                   ref='organizationSearchRef' />
            </div>
          </div>
        </div>

        <div class="form-field">
          <div class="form-field-head">
            <div class="form-field-title">视图管理员：</div>
          </div>
          <div class="form-field-input-container">
            <collaborators-selection extendClass='dataclip-form-collaborators'
                                     @valueChanged='collaboratorsChangedFunc' />
          </div>
        </div>
      </div>

      <div class="modal-footer" slot='footer'>
        <div class="left"></div>
        <div>
          <button class="outlined btn-default" @click='dismissModal'>取消</button>
          <button @click='saveFunc'>确定</button>
        </div>
      </div>
    </modal>
  `,

  computed: {
    remoteUrl() {
      return `/admin${this.resourceGID.toPath()}/user_boundaries/organizations/query?enhanced=true`;
    },

    resourcesUrl() {
      return `/admin${this.resourceGID.toPath()}/user_boundaries/organizations`;
    },
  },

  mounted() {
    this.$refs.organizationSearchRef.selectAll();
  },

  methods: {
    dismissModal() {
      this.$refs.modal.close();
    },

    open() {
      this.$refs.modal.open();
    },

    saveFunc() {
      Skylark.Libs.Ajax.post(`/admin${this.dataclipableGID.toPath()}/dataclips`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          dataclip: this._generateAttributes(),
        },
        success: (data) => {
          const newDataclip = _.first($currentController.constructor.$dataclipsNavigation?.addNode(_.omit(data, 'dataclipable')));
          const dataclipId = data.id;
          newAlertify(`${data.title} 保存成功`, {
            type: 'success',
            textButton: '查看',
            textButtonCallback() {
              if (newDataclip) {
                $currentController.constructor.$dataclipsNavigation?.setActivedNode(newDataclip);
              } else {
                delete $currentController.constructor.$dataclipsNavigation;
              }
              Turbolinks.visit(`/admin/dataclips/${dataclipId}/responses`);
            },
          });
          this.dismissModal();
          this._clearPreviousAttributes();
        },
        error: () => {
          newAlertify('视图创建失败', { type: 'error' });
        },
      });
    },

    updateOrganizationsFunc(organizationsSelectVm) {
      this.userBoundary.organization_ids = _.pluck(organizationsSelectVm.selectedItems, 'composedId');
    },

    collaboratorsChangedFunc(collaboratorIds) {
      this.selectedCollaboratorIds = collaboratorIds;
    },

    setConditions(conditions) {
      this.conditions = conditions;
    },

    setFieldIds(fieldIds) {
      this.field_ids = fieldIds;
    },

    _generateAttributes() {
      return _.tap({
        title: this.title,
        conditions: this.conditions,
        field_ids: this.field_ids,
        collaborator_ids: this.selectedCollaboratorIds,
      }, (obj) => {
        if (this.resourceGID.model_name === 'Dataclip') {
          obj.parent_id = this.resourceGID.model_id;
        }
        if (!_.isBlank(this.userBoundary.organization_ids)) {
          obj.user_boundary_attributes = _.pick(this.userBoundary, 'organization_ids');
        }
      });
    },

    _clearPreviousAttributes() {
      this.title = DEFAULT_TITLE;
    },
  },
});
